module.exports = __webpack_public_path__ + "static/media/it-translation-localization.87885e68.jpg";